// extracted by mini-css-extract-plugin
export default {"footer":"BannerEditModal_footer__gDMW3","cancel_btn":"BannerEditModal_cancel_btn__bCIEK","upload_wrap":"BannerEditModal_upload_wrap__EDfPB"};